<div *ngIf="middleLoading" class="page-wrap align-items-center mt-5" style="overflow: hidden;">
    <div class="container">
        <div class="row justify-content-center">
            <span class="k-icon k-i-loading kendo-loading-icon"></span>
        </div>
    </div>
</div>
<div [ngSwitch]="isGrouped" class="w-100" *ngIf="!middleLoading">
    <div *ngSwitchCase="false">
        <div class="row w-100 ml-4 mr-2">
            <ng-template [ngTemplateOutlet]="titlesTemplate" [ngTemplateOutletContext]="{groupBy: groupBy}">
            </ng-template>
        </div>
        <div class="row mb-2 mt-2 mr-0 ml-0">
            <div class="col-12 d-flex">
                <ng-template [ngTemplateOutlet]="totalsTemplate"
                    [ngTemplateOutletContext]="{totals:channelTotals, total: performanceList.length}">
                </ng-template>
            </div>
        </div>
        <div *ngIf="performanceList.length > 0">
            <div *ngFor="let performance of performanceList" class="col-12 d-flex vertical-line pr-0">
                <div *ngIf="middleLoading" class="row">
                    <div class="col my-auto">
                        <span class="k-icon k-i-loading kendo-loading-icon"></span>
                    </div>
                </div>
                <div *ngIf="!middleLoadling" class="row w-100 d-flex align-items-center">
                    <div class="col-12 d-flex">
                        <ng-template [ngTemplateOutlet]="performanceListTemplate"
                            [ngTemplateOutletContext]="{performance:performance}">
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="performanceList.length === 0" class="h-100">
            <div class="row">
                <div class="col text-left font-weight-bold" style="margin-top: auto;">
                    {{'NO-CASES' | translate}}
                </div>
            </div>
        </div>
    </div>
    <div *ngSwitchCase="true">
        <div class="row w-100 ml-4 mr-2">
            <ng-template [ngTemplateOutlet]="titlesTemplate" [ngTemplateOutletContext]="{groupBy: groupBy}">
            </ng-template>
        </div>
        <div *ngFor="let groupedPerformance of groupedPerformanceList" class="row mb-2 mt-2 mr-0 ml-0">
            <div class="col-12 d-flex">
                <ng-template [ngTemplateOutlet]="totalsTemplate"
                    [ngTemplateOutletContext]="{totals:groupedPerformance.totals, total: groupedPerformance.performanceList.length, group: groupedPerformance.group}">
                </ng-template>
            </div>
            <div *ngFor="let performance of groupedPerformance.performanceList"
                class="col-12 d-flex vertical-line pr-0">
                <ng-template [ngTemplateOutlet]="performanceListTemplate"
                    [ngTemplateOutletContext]="{performance:performance}"
                    *ngIf="!collapsedSections[groupedPerformance.group]">
                </ng-template>
            </div>
        </div>
        <div *ngIf="groupedPerformanceList === undefined || groupedPerformanceList.length === 0" class="h-100">
            <div class="row">
                <div class="col text-left font-weight-bold ml-2" style="margin-top: auto;">
                    {{'NO-CASES' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>

<!-- message dialog-->
<kendo-dialog *ngIf="messageDialogOpened" (close)="messageDialogOpened=false" [minWidth]="400" [width]="700">
    <kendo-dialog-titlebar>
        <h3>{{ 'NEW-MESSAGE' | translate}}</h3>
    </kendo-dialog-titlebar>
    <app-message-compose #messageCompose [messageDialogOpened]="messageDialogOpened" [memberId]="" [caseId]=""
        [messageList]="" [fromMessagesScreen]="'dashboard'" [sendTo]="messageSendTo"
        (afterSave)="messageDialogOpened = false;" (saving)="savingMessage=$event;messageDialogOpened=false">
    </app-message-compose>
    <kendo-dialog-actions>
        <button kendoButton (click)="messageDialogOpened = false" [disabled]="savingMessage">{{ 'CANCEL' | translate
            }}</button>
        <button appPreventClick #submitButton kendoButton type="button"
            [disabled]="!messageCompose.formValid() || savingMessage" (click)="messageCompose.save($event);">
            {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<ng-template #titlesTemplate let-groupBy='groupBy'>
    <div class="col-4 text-center pl-0">
        <span class="text-uppercase label-title montserrat" id="program-channel">{{(groupBy === 'program' ?
            'PROGRAM-CHANNEL' : 'CHANNEL') |
            translate }}
        </span>
    </div>
    <div class="col-4 text-center pl-5">
        <span class="text-uppercase label-title montserrat" id="cases">{{'CASES' | translate}}</span>
    </div>
    <div class="col-1 pl-0">
        <span class="text-uppercase label-title montserrat" id="tasks">{{'TASKS' | translate}}</span>
    </div>
    <div class="col-3 text-center pl-0">
        <span class="text-uppercase label-title montserrat" id="performance">{{'PERFORMANCE' | translate}}</span>
    </div>
</ng-template>

<ng-template #totalsTemplate let-totals='totals' let-total='total' , let-group='group'>
    <div class="h-100" class="w-100">
        <!--Program-->
        <div>
            <div *ngIf="middleLoading" class="row">
                <div class="col my-auto">
                    <span class="k-icon k-i-loading kendo-loading-icon"></span>
                </div>
            </div>
            <div *ngIf="!middleLoadling" class="row w-100 d-flex align-items-center">
                <div class="col-5 my-auto">
                    <div class="row h-100">
                        <div class="col">
                            <div *ngIf="groupBy === 'program'">
                                <div class="row">
                                    <div class="col text-justify my-auto label-channel montserrat pl-0 collapsible-text"
                                        style="margin-top: auto;" (click)="channelToggle(group)"
                                        aria-describedby="program-channel" role="link">
                                        {{totals.programName}}
                                        <span class="badge badge-pill badge-secondary ml-2 badge-channel-group">
                                            {{total}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div *ngIf="groupBy === 'program'" id="program-lead"
                                        class="col text-justify my-auto label-total montserrat pl-0 text-uppercase"
                                        style="margin-bottom:auto;font-size:smaller;">
                                        {{'PROGRAM-LEAD' | translate}}:&nbsp;
                                        <a (click)="sendMessageToProgramLead(totals.programLeadId)"
                                            (keydown.enter)="sendMessageToProgramLead(totals.programLeadId)"
                                            class="pointer text-uppercase" aria-describedby="program-lead"
                                            (keydown.space)="sendMessageToProgramLead(totals.programLeadId)"
                                            tabindex="0">{{totals.programLead}}</a>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="groupBy !== 'program' && groupBy !== undefined && group !== undefined">
                                <div class="row">
                                    <div class="col text-justify my-auto label-channel montserrat pl-0 collapsible-text"
                                        style="margin-top: auto;" (click)="channelToggle(group)">
                                        {{group | splitString: '|' : 0}}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="groupBy === undefined">
                                <div class="row">
                                    <div class="col text-justify my-auto label-channel montserrat pl-0"
                                        style="margin-top: auto;">
                                        {{'TOTAL' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-5 my-auto">
                    <div class="row mr-3">
                        <div class="col-4 my-auto text-center text-uppercase label-total montserrat">
                            <span [ngClass]="{'label-with-datas': totals.openCases > 0}">
                                {{totals.openCases | roundNumber}} {{'OPEN' | translate}}
                            </span>
                        </div>
                        <div class="col-3 my-auto text-center text-uppercase label-total montserrat">
                            <span [ngClass]="{'label-with-datas': totals.closedCases > 0}">
                                {{totals.closedCases | roundNumber}} {{'CLOSED' | translate}}
                            </span>
                        </div>
                        <div class="col-3 my-auto text-center text-uppercase label-total montserrat">
                            <span [ngClass]="{'alert': totals.lateTasks > 0}">
                                {{totals.lateTasks | roundNumber}} {{'LATE' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-2 my-auto text-right pr-0" *ngIf="isGrouped">
                    <app-collapsible #collapsibles [useSessionStorage]="true" [storageKey]="'dashboard-list-' + group"
                        [updateCollapse]="collapse" (collapsibleToggle)="updateProgramCollapse(group, $event)">
                    </app-collapsible>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!--Performances Template-->
<ng-template #performanceListTemplate let-performance='performance'>
    <div class="h-100 w-100 p-1">
        <div [ngClass]="{'card':true, 'card-shadow':true, 'h-100':true, 'text-center':true, 'w-100':true}">
            <!--Channel-->
            <div class="card-body d-flex justify-content-center">
                <div *ngIf="middleLoading" class="row">
                    <div class="col my-auto">
                        <span class="k-icon k-i-loading kendo-loading-icon"></span>
                    </div>
                </div>
                <div *ngIf="!middleLoadling" class="row w-100 d-flex align-items-center">
                    <div class="col-5 my-auto">
                        <div class="row h-100 pl-1">
                            <div class="col-12">
                                <div class="row" [ngClass]="{'h-100': groupBy === 'program'}">
                                    <div class="col text-left my-auto" style="margin-top: auto;">
                                        <a *ngxPermissionsOnly="['ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT']"
                                            [routerLink]="['/channel-detail', performance.channelId]"
                                            class="pointer label-name montserrat font-weight-bold"
                                            aria-describedby="program-channel"
                                            title="{{'CHANNEL-OVERVIEW' | translate}} - {{performance.channelName}} ({{performance.programCategoryName}})">
                                            {{performance.channelName}}
                                        </a>
                                        <span *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR']"
                                            class="label-name montserrat">
                                            {{ performance.channelName }}
                                        </span>
                                    </div>
                                </div>
                                <div class="row" *ngIf="groupBy !== 'program'">
                                    <div class="col text-left label-program-lead my-auto" style="margin-bottom: auto;">
                                        {{'PROGRAM-LEAD' | translate}}:&nbsp;
                                        <a class="pointer"
                                            (click)="sendMessageToProgramLead(performance.programLeadId)">{{performance.programLead}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 my-auto">
                        <div class="row">
                            <div class="col-4 my-auto">
                                <div class="text-uppercase label-performance montserrat">
                                    <a *ngIf="performance.openCases > 0" [routerLink]="['/cases/active']"
                                        [queryParams]="{channel: performance.channelId, allAssignee: false}"
                                        class="pointer" aria-describedby="cases">
                                        <div>
                                            {{performance.openCases | roundNumber}}
                                        </div>
                                        <div class="label-performance-count" style="color: #527186">
                                            {{'OPEN' | translate}}
                                        </div>
                                    </a>
                                    <span *ngIf="performance.openCases === 0">
                                        <div>
                                            {{performance.openCases | roundNumber}}
                                        </div>
                                        <div class="label-performance-count">
                                            {{'OPEN' | translate}}
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-4 my-auto">
                                <div class="text-uppercase label-performance montserrat">
                                    <a *ngIf="performance.totalUserCasesClose > 0" [routerLink]="['/cases/all']"
                                        aria-describedby="cases"
                                        [queryParams]="{channel: performance.channelId, allAssignee: false, closedCases: true}"
                                        class="pointer">
                                        <div>
                                            {{performance.totalUserCasesClose | roundNumber}}
                                        </div>
                                        <div class="label-performance-count" style="color: #527186">
                                            {{'CLOSED' | translate}}
                                        </div>
                                    </a>
                                    <span *ngIf="performance.totalUserCasesClose === 0">
                                        <div>
                                            {{performance.totalUserCasesClose | roundNumber}}
                                        </div>
                                        <div class="label-performance-count">
                                            {{'CLOSED' | translate}}
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-4 my-auto">
                                <div class="text-uppercase label-performance montserrat">
                                    <a *ngIf="performance.lateTasks > 0" [routerLink]="['/tasks/active']"
                                        aria-describedby="tasks"
                                        [queryParams]="{channel: performance.channelId, allAssignee: false }"
                                        class="pointer text-alert">
                                        <div>
                                            {{performance.lateTasks | roundNumber}}
                                        </div>
                                        <div class="label-performance-count" style="color: #527186">
                                            {{'LATE' | translate}}
                                        </div>
                                    </a>
                                    <span *ngIf="performance.lateTasks === 0">
                                        <div>
                                            {{performance.lateTasks | roundNumber}}
                                        </div>
                                        <div class="label-performance-count">
                                            {{'LATE' | translate}}
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="row">
                            <div class="col-10"
                                [ngClass]="{'col-12': !isDashboardEnrollmentEnabled, 'p-0': isDashboardEnrollmentEnabled}">
                                <kendo-chart style="position: absolute; height: 60px; width: 100%;"
                                    aria-describedby="performance" *ngIf="performance.channelSuccess > 0">
                                    <kendo-chart-area opacity="0"></kendo-chart-area>
                                    <kendo-chart-tooltip format='{0}%'></kendo-chart-tooltip>
                                    <kendo-chart-category-axis>
                                        <kendo-chart-category-axis-item [categories]="[labelYou,labelTeam]">
                                        </kendo-chart-category-axis-item>
                                    </kendo-chart-category-axis>
                                    <kendo-chart-series>
                                        <kendo-chart-series-item type="bullet"
                                            [data]="[[performance.performanceUser, performance.channelSuccess], [performance.performanceTeam, performance.channelSuccess]]"
                                            [color]="barColor" [gap]="0.5">
                                        </kendo-chart-series-item>
                                    </kendo-chart-series>
                                    <kendo-chart-value-axis>
                                        <kendo-chart-value-axis-item [majorGridLines]="hidden" [minorTicks]="hidden"
                                            [min]="0" [max]="100" [visible]="false">
                                            <kendo-chart-category-axis-item-labels format="{0}%">
                                            </kendo-chart-category-axis-item-labels>
                                        </kendo-chart-value-axis-item>
                                    </kendo-chart-value-axis>
                                </kendo-chart>
                                <div class="text-uppercase label-total montserrat"
                                    *ngIf="performance.channelSuccess === 0">
                                    {{'NO-TARGET-DEFINED' | translate}}
                                </div>
                            </div>
                            <div class="col-2 my-auto" *ngIf="performance.isDashboardEnrollment">
                                <i class="fas fa-1_5x fa-user-plus pointer label-with-datas" sstyle="color: #527186;"
                                    title="{{'ENROLL-CLIENT' | translate:patientLabel}}"
                                    (click)="enrollPatient(performance.channelId, performance.channelName)">
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<kendo-dialog [width]="1300" *ngIf="searchMembersToEnroll" (close)="closeMemberEnrollmentModal()">
    <kendo-dialog-titlebar>
        <h3>{{'ENROLL-A-MEMBER-TO' | translate: patientLabel}} {{enrollChannelName}}</h3>
    </kendo-dialog-titlebar>
    <kendo-tabstrip #enrollTabstrip>
        <kendo-tabstrip-tab *ngIf="nextAvailableEnabled" title="{{ 'SEARCH-TAB-NEXT-AVAILABLE' | translate }}"
            [selected]="selectedEnrollmentTab === 0">
            <ng-template kendoTabContent>
                <div class="m-2">
                    <app-member-search [showHeader]="false" [nextAvailableEnabled]="nextAvailableEnabled"
                        [displayTab]="false" [enrollChannelId]="enrollChannelId" [enrollChannelName]="enrollChannelName"
                        [maxGridHeight]="600" (completeEnrollments)="completedEnrollments()">
                    </app-member-search>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'SEARCH-TAB-SPECIFIC' | translate:patientLabel }}"
            [selected]="selectedEnrollmentTab === 1">
            <ng-template kendoTabContent>
                <div class="m-2">
                    <app-member-search [showHeader]="false" [nextAvailableEnabled]="false"
                        [nextAvailableEnabledNoOpenCaseOnly]="nextAvailableEnabled" [displayTab]="false"
                        [enrollChannelId]="enrollChannelId" [enrollChannelName]="enrollChannelName"
                        [maxGridHeight]="300" (completeEnrollments)="completedEnrollments()">
                    </app-member-search>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="closeMemberEnrollmentModal()">
            {{ 'CLOSE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>